import { Map } from "immutable";
import { combineReducers } from "redux";
import * as actionTypes from "~/store/action_types";

const all_countries = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_COUNTRIES_SUCCESS: {
      if (!action.response) {
        return state;
      }
      return state.merge(action.response);
    }
    default:
      return state;
  }
};

const states = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_COUNTRY_STATES_SUCCESS: {
      if (!action.response) {
        return state;
      }
      return state.merge(action.response);
    }
    default:
      return state;
  }
};

const eu_countries = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_EU_COUNTRIES_SUCCESS: {
      if (!action.response) {
        return state;
      }
      return state.merge(action.response);
    }
    default:
      return state;
  }
};

export default combineReducers({
  all_countries,
  states,
  eu_countries,
});
